import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

export const authGuard: CanMatchFn = (route, state) => {
  const authService = inject(LocalStorageService);
  const router = inject(Router);
  if (authService.isLoggedIn()) {
    return true; 
  } else {
    router.navigate(['/login']);
    return false;
  }  
};


export const permissionGuard: CanMatchFn = (route, state) => {
  const authService = inject(LocalStorageService);
  const router = inject(Router);
  if (authService.isLoggedIn()) {
    let permissionName = route['data']?.["PERMISSION"] ?? "";
    let result = authService.checkPermission(permissionName);
    if(!result){
      router.navigate(['/no-access']);
      return false;
    }
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }  
};

